/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ClearOrgPriceRequest = {
  orgId: string;
  model: string;
};

/** @internal */
export const ClearOrgPriceRequest$inboundSchema: z.ZodType<
  ClearOrgPriceRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  model: z.string(),
});
/** @internal */
export type ClearOrgPriceRequest$Outbound = {
  orgId: string;
  model: string;
};

/** @internal */
export const ClearOrgPriceRequest$outboundSchema: z.ZodType<
  ClearOrgPriceRequest$Outbound,
  z.ZodTypeDef,
  ClearOrgPriceRequest
> = z.object({
  orgId: z.string(),
  model: z.string(),
});

export function clearOrgPriceRequestToJSON(
  clearOrgPriceRequest: ClearOrgPriceRequest,
): string {
  return JSON.stringify(
    ClearOrgPriceRequest$outboundSchema.parse(clearOrgPriceRequest),
  );
}
export function clearOrgPriceRequestFromJSON(
  jsonString: string,
): SafeParseResult<ClearOrgPriceRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClearOrgPriceRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClearOrgPriceRequest' from JSON`,
  );
}
